import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white dark:bg-black">
        <div className="text-xs tracking-overline uppercase text-black/45 dark:text-white/45">
          Checking access…
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/crm/login" replace state={{ from: location }} />;
  }

  return children;
}
